import React from 'react';

interface CardSkeletonProps {
  type?: 'default' | 'vote';
  count?: number;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ type = 'default', count = 1 }) => {
  const baseClassName = "animate-shimmer rounded-md shadow-md p-4";
  const shimmerBaseColor = "bg-gray-100";
  const textPlaceholderBase = "h-3 rounded bg-opacity-70";
  const avatarPlaceholder = "w-10 h-10 rounded-full border-2 border-indigo-300";
  const buttonPlaceholder = "rounded-md h-8 w-1/2";

  if (type === 'vote') {
    return (
      <div className='flex justify-center flex-wrap gap-4 lg:gap-20'>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="w-80"> {/* Adjust width as needed and wrap each card */}
            <div className={`${baseClassName} ${shimmerBaseColor}`}>
              {/* Top Section */}
              <div className="flex justify-end mb-2">
                <div className="bg-[#e0e0e0] bg-opacity-70 rounded-full h-6 w-16 flex items-center justify-center text-sm">
                  <div className="w-3 h-3 rounded-full mr-1 bg-[#c8c8c8] bg-opacity-70"></div>
                  <div className={`${textPlaceholderBase} w-10 bg-[#c8c8c8]`}></div>
                </div>
              </div>

              {/* Image Area */}
              <div className="rounded-t-md overflow-hidden mb-3 relative">
                <div className="h-40 bg-[#d1d1d1] bg-opacity-70 w-full"></div>
                <div className="absolute bottom-2 left-4">
                  {/* <div className={`${textPlaceholderBase} h-6 w-32 bg-[#f0f0f0]`}></div> */}
                </div>
              </div>

              {/* Description */}
              <div className="mb-4">
                <div className={`${textPlaceholderBase} w-64 bg-[#e8e8e8] mb-1`}></div>
                <div className={`${textPlaceholderBase} w-56 bg-[#e8e8e8] mb-1`}></div>
                <div className={`${textPlaceholderBase} w-48 bg-[#e8e8e8]`}></div>
              </div>

              {/* Bottom Button */}
              <div className="rounded-md bg-[#9b80e0] bg-opacity-70 h-10 flex items-center justify-center">
                <div className={`${textPlaceholderBase} h-4 w-40 bg-[#ad95e9]`}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Default Card Skeleton
  return (
    <div className={`${baseClassName} bg-indigo-100 border border-indigo-200`}>
      {/* Top Section */}
      <div className="flex items-center space-x-3 mb-3">
        <div className={`${avatarPlaceholder} bg-[#ddd3ff]`}></div>
        <div className="flex-1">
          <div className={`${textPlaceholderBase} h-4 w-24 bg-[#fce4ec]`}></div>
          <div className={`${textPlaceholderBase} w-32 mt-1 bg-[#f0f4c3]`}></div>
        </div>
        <div className={`${textPlaceholderBase} rounded-full h-5 w-10 bg-[#c5b3ff]`}></div>
      </div>

      {/* Middle Section */}
      <div className="mb-3">
        <div className={`${textPlaceholderBase} w-20 mb-1 bg-[#ede7f6]`}></div>
        <div className={`${textPlaceholderBase} h-4 w-48 bg-[#e3f2fd]`}></div>
        <div className="flex items-center space-x-2 mt-2">
          <div className={`${textPlaceholderBase} w-24 bg-[#ede7f6]`}></div>
          <div className="w-3 h-3 rounded-full bg-[#b2ebf2]"></div>
          <div className={`${textPlaceholderBase} w-16 bg-[#fff9c4]`}></div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mb-4">
        <div className={`${textPlaceholderBase} w-40 mb-1 bg-[#f8bbd0]`}></div>
        <div className={`${textPlaceholderBase} w-48 mb-1 bg-[#e1bee7]`}></div>
        <div className={`${textPlaceholderBase} w-32 bg-[#bbdefb]`}></div>
      </div>

      {/* Footer Section */}
      <div className="flex space-x-2">
        <div className={`${buttonPlaceholder} bg-[#b9fca0]`}></div>
        <div className={`${buttonPlaceholder} bg-[#c5b3ff]`}></div>
      </div>
    </div>
  );
};

export default CardSkeleton;